export interface ReportData {
  roadmap: string;
  classes: string[];
  sites: string;
  standards: string;
  groupedBy: ReportGroupBy;
  orderBy: ReportOrderBy;
}

export enum ReportType {
  DIAGNOSTIC,
  PROGRESS,
}

export enum ReportGroupBy {
  UNIT,
  STANDARD,
}

export enum ReportOrderBy {
  ROWS,
  COLUMNS,
}

export enum ReportSubtype {
  DIAGNOSTIC_SUMMARY,
  DIAGNOSTIC_STUDENTS_UNFINISHED_DIAGNOSTIC,
  PROGRESS_DETAILED_SKILL_REPORT,
  PROGRESS_SKILL_ASSESSMENT_HISTORY,
}

export const reportData = {
  DiagnosticSummary: {
    header: 'Diagnostic Skill Performance By Class',
    summary:
      'This report summarizes student diagnostic results by skill, showing how many students placed out or did not place out of each skill on their Roadmap. It helps identify skills your students have already mastered and potential focus points for instruction.',
  },
  DiagnosticStudentUnfinishedDiagnostic: {
    header: 'Student Diagnostic Details',
    summary:
      'This report lists student-level diagnostic details for your class(es), including completion status, date, demonstrated skills, and projected status at 2 or 3 skills per week. Use it to review progress and plan targeted follow-up.',
  },
  ProgressDetailedSkillReport: {
    header: 'Detailed Skill Report',
    summary:
      'This report shows individual student performance on each skill for the selected Roadmap, organized by unit or standard. It also summarizes class-wide performance, allowing you to seamlessly zoom in and out to focus on student, class, or unit/standard-level details.',
  },
  ProgressSkillSAssessmentHistory: {
    header: 'Skill Assessment History',
    summary:
      'This report tracks student performance on skill assessments, showing attempts and outcomes for each skill. Organized by student, it provides insights into student persistence, progress, and skills requiring additional support.',
  },
  ProgressSkillChallengeHistory: {
    header: 'Skill Challenge History',
    summary:
      'This report tracks student performance on skill challenges, showing attempts and outcomes for each skill. Organized by student, it provides insights into student persistence, progress, and skills requiring additional support.',
  },
};
